import { createStore, createLogger } from 'vuex';
import { store as auth, AuthStore, State as AuthState } from '@/store/auth';
import { store as menu, MenuStore, State as MenuState } from '@/store/menu';
import { store as message, MessageStore, State as MessageState } from '@/store/messages';
import { store as loader, LoaderStore, State as LoaderState } from '@/store/loader';
import { store as grid, GridStore, State as GridState } from '@/store/grid';
import { store as modal, ModalStore, State as ModalState } from '@/store/modal';
import {
  store as acompanhamentoAta,
  AcompanhamentoAtaStore,
  State as AcompanhamentoAtaState,
} from '@/store/acompanhamentoata';
import {
  store as calendario,
  CalendarioStore,
  State as CalendarioState,
} from '@/store/calendario';

export type RootState = {
  auth: AuthState;
  menu: MenuState;
  loader: LoaderState,
  message: MessageState,
  grid: GridState,
  modal: ModalState;
  acompanhamentoAta: AcompanhamentoAtaState;
  calendario: CalendarioState;
};

export type Store = AuthStore<Pick<RootState, 'auth'>>
  & MenuStore<Pick<RootState, 'menu'>> & LoaderStore<Pick<RootState, 'loader'>> & MessageStore<Pick<RootState, 'message'>>
  & GridStore<Pick<RootState, 'grid'>> & ModalStore<Pick<RootState, 'modal'>>
  & AcompanhamentoAtaStore<Pick<RootState, 'acompanhamentoAta'>>
  & CalendarioStore<Pick<RootState, 'calendario'>>;

// Plug in logger when in development environment
const debug = process.env.NODE_ENV !== 'production';
const plugins = debug ? [createLogger({})] : [];



export const store = createStore({
  plugins,
  modules: {
    menu,
    auth,
    loader,
    message,
    grid,
    modal,
    acompanhamentoAta,
    calendario,
  },
});

export function useStore(): Store {
  return store as Store;
}
